import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PopupContainer } from '../../common/components';
import { PopupButtons } from '../../common/components/popup';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';
import { IPopupProps } from './types.type';
import useAuth from '../../auth/feature/auth';
import { queryClient } from '../../app/queryClient';
import { authService } from '../../auth/service/auth.service';

export const Logout = ({ isOpen, onClose }: IPopupProps) => {
  const { t } = useTranslation();
  const { setIsAuthenticated } = useAuth();
  const navigate = useNavigate();

  const logoutHandler = async () => {
    await authService.logout();
    setIsAuthenticated(false);
    onClose();
    queryClient.clear();
    navigate(ROUTER_LINKS.ROOT);
  };

  return (
    <PopupContainer
      caption={t('settings.logoutConfirm')}
      isOpen={isOpen}
      onClose={onClose}
    >
      <PopupButtons onClick={logoutHandler} text={t('header.logout')} onClose={onClose} />
    </PopupContainer>
  );
};
